import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScholarshipService {

  constructor(private http: CustomHttpService) { }

  // Get all scholarships with count
  getAllScholarshipsWithCount(payload: any): Observable<any> {
    return this.http.post(environment.getAllScholarshipsWithCount, payload);
  }

  // Create scholarship
  createScholarship(payload: any): Observable<any> {
    return this.http.post(environment.createScholarship, payload);
  }

  // Update scholarship
  updateScholarship(payload: any): Observable<any> {
    return this.http.post(environment.updateScholarship, payload);
  }

  // Delete scholarship
  deleteScholarship(payload: any): Observable<any> {
    return this.http.post(environment.deleteScholarship, payload);
  }

  getAllScholarships(params: any): Observable<any> {
    return this.http.post(environment.getAllScholarships, params);
  }

  // Get scholarship by ID
  getScholarshipById(id: number): Observable<any> {
    return this.http.get(`${environment.getScholarshipById}/${id}`);
  }
}